<template>
	<div id="app">
		<div id="fullpage">
			<div class="section" id="section0">
				<Video :sectionsIndex="sectionsIndex" />
			</div>
			<div class="section" id="section1">
				<div class="product-container">
					<div class="slide" :key="'slide' + (index+1)" v-bind="{'id': 'slide' + (index+1)}" v-for="(item, index) in product">
						<div class="photo">
							<div></div>
						</div>
						<div class="infomation-name">
							<h2>产品</h2>
							<h4>{{item.name}}</h4>
						</div>
<!--						<div class="infomation-type">-->
<!--							{{item.type}}-->
<!--						</div>-->
						<div class="infomation-infos">
							<h3 v-bind="{'ref': item.type}">{{item.detail}}</h3>
<!--							<div v-bind="{'ref': item.type + 'title'}" class="title">功能特征</div>-->
<!--							<ul>-->
<!--								<li :key="item.type+i" v-bind="{'ref': item.type+i}" v-for="(t, i) in item.detail">{{i+1}}. {{t}}</li>-->
<!--							</ul>-->
						</div>

            <Qrcode class="qrcode" text="扫码看视频介绍"/>
					</div>

					<div class="fp-controlArrow fp-prev n-fp-controlArrow n-fp-prev"></div>
					<div class="fp-controlArrow fp-next n-fp-controlArrow n-fp-next"></div>
				</div>
			</div>
			<div class="section" id="section2">
				<Server />
			</div>
			<div class="section" id="section3">
				<About :sectionsIndex="sectionsIndex" />
			</div>
		</div>

		<div class="login fadeInScale">
			<img src="../../assets/images/logo_white.png" >
      <h1>识加科技</h1>
		</div>

		<!-- let anchors = ['home', 'product', 'server', 'about']; -->
		<div id="menu-bar" @click="menuVisible=true">
			<div @click="handlerAnchor('home')"><a href="javascript:;">首页</a></div>
			<div @click="handlerAnchor('product')"><a href="javascript:;">AI产品</a></div>
			<div @click="handlerAnchor('server')"><a href="javascript:;">行业方案</a></div>
			<div @click="handlerAnchor('about')"><a href="javascript:;">关于我们</a></div>
			<!-- <span class="title">菜单</span> -->
			<!-- <img src="../../assets/images/menu.png" alt=""> -->
		</div>
		
		<div class="arrow twinkle" v-if="sectionsIndex < options.anchors.length-1" @click="next"></div>

		<div class="copyright fadeInUpBig" v-if="sectionsIndex < options.anchors.length-1">
      <p>©2016-{{year}} 上海识加电子科技有限公司</p>
      <p class="copyright-code">沪ICP备16034377号-1</p>
    </div>
		
			<div class="mask" :class="{'mask-scale': menuVisible}"></div>
			<div class="close" @click="menuVisible = false"><span>关闭</span> <img src="../../assets/images/close.png" alt=""></div>
			<div class="menu-wapper" :class="{'menu-scale': menuVisible}">
				<div class="menu-column">
					<div class="menu-center">
						<h1>AI产品 <span><span></span><span></span><span></span></span></h1>
						<div @click="handlerAnchor('product', 0)"><a href="javascript:;">EKS339</a></div>
						<div @click="handlerAnchor('product', 1)"><a href="javascript:;">EKR200</a></div>
						<div @click="handlerAnchor('product', 2)"><a href="javascript:;">DSM</a></div>
						<div @click="handlerAnchor('product', 3)"><a href="javascript:;">ADAS</a></div>
						<div @click="handlerAnchor('product', 4)"><a href="javascript:;">BSD</a></div>
					</div>
				</div>

				<div class="menu-column">
					<div class="menu-center">
						<h1>行业解决方案 <span><span></span><span></span><span></span></span></h1>
						<div @click="handlerAnchor('server', 0)"><a href="javascript:;">行车安全解决方案</a></div>
						<div @click="handlerAnchor('server', 1)"><a href="javascript:;">车队培训解决方案</a></div>
					</div>
				</div>

				<div class="menu-column">
					<div class="menu-center">
						<h1>关于我们 <span><span></span><span></span><span></span></span></h1>
						<div @click="handlerAnchor('about')"><a href="javascript:;">企业介绍</a></div>
						<div @click="handlerAnchor('about')"><a href="javascript:;">联系方式</a></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Qrcode from '../qrcode.vue'
import Video from './video.vue'
import Server from './server.vue'
import About from './about.vue'
import AntvG2 from '@/utils/antvg2.js'

let myFullpage;
	let timer;

	let product = [
		{ name: '螃蟹分拣机', type: 'EKS339', detail: '这款精密分拣机器的构造主要由称重模块、精密摄像机、高灵敏度传感器、多功能机械臂、优质伺服电机、高效单片机、强大的上位机以及先进的软件算法等组成。它能够自动依照螃蟹的重量或壳长进行细致的等级分类，完美取代了传统的人工分拣方式。此外，这种自动化分拣方法不仅能显著提升分拣的效率和准确性，同样也能有效降低人力资源投入，实现经济效益和工作效率的双重提升。' },
		{ name: '螃蟹测量机', type: 'EKR200', detail: '我们精心打造的螃蟹表型性状测量装置，致力于通过先进的图像算法，识别和分析蟹背上多个关键视觉点位。通过计算这些关键点之间的距离以及其重量，装置能够精准地推测出螃蟹的壳长和肥满度。借此，我们可以深入研究并了解螃蟹在不同养殖周期中的生长变化规律，为养殖者提供更为科学、精细的养殖方案。' },
		{ name: '螃蟹喂料机', type: 'DSM', detail: '螃蟹喂料机领养殖新纪元，我们自豪推出全方位智能养殖解决方案！智能投料机，精准定时定量投喂，有效避免饲料浪费，大幅节省饲料成本，让每一份投入都精准高效。搭配智能巡检机，实现24小时不间断健康监测，任何细微异常都逃不过它的“火眼金睛”，确保养殖环境安全无忧。更有智能清洗机自动清洁养殖水槽，保持水体清澈卫生，从源头降低病害风险，为养殖生物营造健康生长乐园' },
	]

	let anchors = ['home', 'product', 'server', 'about'];

	let barDate = [
		{ type: '2014', value: 654, percent: 37.69 },
		{ type: '2015', value: 654, percent: 24.32 },
		{ type: '2016', value: 654, percent: 18.74 },
		{ type: '2017', value: 654, percent: 9.46 },
		{ type: '2018', value: 654, percent: 6.79 }
	]

	export default {
		name: 'index',
		components: { Video, Server, About ,Qrcode},
		data() {
			return {
				year: new Date().getFullYear(),
				menuVisible: false,
				sectionsIndex: 0,
				swiperIndex: 0,

				product: product,
				barDate: barDate,
				options: {
					verticalCentered: false,
					css3: false,
					anchors: anchors,
					onLeave: this.onLeave,
					afterLoad: this.afterLoad,
					afterSlideLoad: this.afterSlideLoad,
					onSlideLeave: this.onSlideLeave
				}
			}
		},
		mounted() {
			myFullpage = new fullpage('#fullpage', this.options);

			// AntvG2.Bar({
			// 	el: 'mountNode',
			// 	list: barDate,
			// 	height: '350',
			// 	position: ['type', 'percent'],
			// 	title: '比例',
			// 	padding: [40, 40, 40, 40]
			// });
		},
		methods: {
			next() {
				if (this.sectionsIndex < anchors.length-1) {
					this.sectionsIndex++;
					window.fullpage_api.moveTo(anchors[this.sectionsIndex]);
				}
			},
			handlerAnchor(anchor, index) {
				anchors.map((item, i) => {
					if (item == anchor) {
						window.fullpage_api.moveTo(anchors[i], index);
					}
				})

				this.menuVisible = false;
			},
			onLeave(origin, destination) {
				this.sectionsIndex = destination.index;

				if (destination.index == 1) {
					document.querySelectorAll('.infomation-name h2')[0].classList.add('fadeInDown');
					document.querySelectorAll('.photo div')[0].classList.add('fadePhoto');

					setTimeout(() => {
						document.querySelectorAll('.infomation-name h2')[0].classList.remove('fadeInDown');
						document.querySelectorAll('.photo div')[0].classList.remove('fadePhoto');
					}, 2000);
				}
			},
			afterLoad(origin, destination) {
				if (destination.index == 2) {
					timer = setInterval(() => {
						window.fullpage_api.moveSlideRight();
					}, 5000);
				}else {
					clearInterval(timer);
				}

				// fnProductAnimate(this, destination);
			},
			onSlideLeave(origin, destination, direction) {
				product.map(item => {
					this.$refs[item.type].style.right = '-9999px';
					// this.$refs[item.type + 'title'].style.right = '-9999px';

					// item.detail.map((t, i) => {
					// 	this.$refs[item.type + i].style.right = '-9999px';
					// })
				})

				if (origin.index == 1) {
					this.swiperIndex = direction.index;
					document.querySelectorAll('.infomation-name h2')[this.swiperIndex].classList.add('fadeInDown');
					document.querySelectorAll('.photo div')[this.swiperIndex].classList.add('fadePhoto');

					setTimeout(() => {
						document.querySelectorAll('.infomation-name h2')[this.swiperIndex].classList.remove('fadeInDown');
						document.querySelectorAll('.photo div')[this.swiperIndex].classList.remove('fadePhoto');
					}, 2000);


					let type = product[this.swiperIndex].type;
					let _size = parseFloat(getStyle(document.querySelector('html'), 'fontSize'));
					let _right = 584*_size/192;

					if (window.innerWidth <= 1024) {
						this.$refs[type].style.right = 0;
						// this.$refs[type + 'title'].style.left = (window.innerWidth - 70)/2 + 'px';

						// product[this.swiperIndex].detail.map((item, index) => {
						// 	this.$refs[type + index].style.right = 0;
						// })
					}else{
						this.$refs[type].style.right = _right - this.$refs[type].offsetWidth + 'px';
						// this.$refs[type + 'title'].style.right = _right - this.$refs[type + 'title'].offsetWidth + 'px';

						// product[this.swiperIndex].detail.map((item, index) => {
						// 	this.$refs[type + index].style.right = _right - this.$refs[type + index].offsetWidth + 'px';
						// })
					}
				}
			}
		}
	}

	// function fnProductAnimate(that, params) {
	// 	if (params.index == 1) {
	// 		let type = product[that.swiperIndex].type;
	// 		let _size = parseFloat(getStyle(document.querySelector('html'), 'fontSize'));
	// 		let _right = 584*_size/192;
  //
	// 		if (window.innerWidth <= 1024) {
	// 			that.$refs[type].style.right = 0;
	// 			that.$refs[type + 'title'].style.left = (window.innerWidth - 70)/2 + 'px';
  //
	// 			product[that.swiperIndex].detail.map((item, index) => {
	// 				that.$refs[type + index].style.right = 0;
	// 			})
	// 		}else{
	// 			that.$refs[type].style.right = _right - that.$refs[type].offsetWidth + 'px';
	// 			that.$refs[type + 'title'].style.right = _right - that.$refs[type + 'title'].offsetWidth + 'px';
  //
	// 			product[that.swiperIndex].detail.map((item, index) => {
	// 				that.$refs[type + index].style.right = _right - that.$refs[type + index].offsetWidth + 'px';
	// 			})
	// 		}
	// 	}else{
	// 		product.map(item => {
	// 			that.$refs[item.type].style.right = '-9999px';
	// 			that.$refs[item.type + 'title'].style.right = '-9999px';
  //
	// 			item.detail.map((t, i) => {
	// 				that.$refs[item.type + i].style.right = '-9999px';
	// 			})
	// 		})
	// 	}
	// }

	function getStyle(obj, name) {
		return (obj.currentStyle || document.defaultView.getComputedStyle(obj, false))[name];
	}
</script>

<style lang="scss">
	@import '../../styles/fullpage.css';
	@import '../../styles/base.scss';
	
	@media screen and (min-width: 980px) {
		@import '../../styles/index.scss';
	}

	@media screen and (max-width: 980px) {
		@import '../../styles/media980.scss';
	}
</style>
